import { ref, watch, nextTick } from 'vue'

export function useAutoScroll(dependency) {
  const container = ref(null)
  const userScrolledUp = ref(false)

  function onScroll() {
    if (!container.value) return
    const el = container.value.$el || container.value
    const threshold = 100
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < threshold
    userScrolledUp.value = !atBottom
  }

  function scrollToBottom() {
    if (userScrolledUp.value) return
    nextTick(() => {
      if (!container.value) return
      const el = container.value.$el || container.value
      el.scrollTop = el.scrollHeight
    })
  }

  watch(dependency, scrollToBottom, { deep: true })

  return { container, onScroll, scrollToBottom, userScrolledUp }
}
